  const subscriptionHandles = [
    'day-night-duo',
    'dreamy-melts',
    'kanna-wellness-bundle',
    'mary-jane-sampler',
    'simple-sunny-melts',
    'sunny-lovers',
    'sunny-melts',
    'sunny-trio',
    'super-sunny'
  ];

  function checkForSubscriptionProducts() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const hasValidSubscription = cart.items.some(item => {
          const isSubscription = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.name;
          return (
            subscriptionHandles.includes(item.handle) &&
            isSubscription &&
            item.selling_plan_allocation.selling_plan.name.includes("Deliver Every")
          );
        });

        const subMsg = document.getElementById('subscription-message');
        const defaultFreeShipping = document.querySelector('free-shipping.free-shipping:not(#subscription-message free-shipping)');

        if (hasValidSubscription) {
          if (subMsg) subMsg.style.display = 'block';
          if (defaultFreeShipping) defaultFreeShipping.style.display = 'none';
        } else {
          if (subMsg) subMsg.style.display = 'none';
          if (defaultFreeShipping) defaultFreeShipping.style.display = 'block';
        }
      });
  }

  document.addEventListener('DOMContentLoaded', () => {
    checkForSubscriptionProducts();
    setInterval(checkForSubscriptionProducts, 1500);
  });












  function initCartDrawerTestimonials() {
    const slider = document.querySelector('.cart-drawer-testimonials');
    if (slider && typeof Flickity !== 'undefined' && !slider.classList.contains('flickity-enabled')) {
      new Flickity(slider, {
        freeScroll: true,
        prevNextButtons: false,
        cellAlign: 'left',
        contain: true,
        groupCells: true,
        pageDots: true,
        draggable: true
      });
    }
  }

  // ✅ Load on DOM ready
  document.addEventListener('DOMContentLoaded', initCartDrawerTestimonials);

  // ✅ Observe cart drawer content changes (AJAX updates)
  const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('#Cart-Drawer');
  if (cartDrawer) {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.type === 'childList' &&
          mutation.addedNodes.length &&
          document.querySelector('.cart-drawer-testimonials')
        ) {
          initCartDrawerTestimonials();
          break;
        }
      }
    });

    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  // ✅ Fallback: setInterval polling if MutationObserver is too early
  let attempts = 0;
  const maxAttempts = 10;
  const pollInterval = setInterval(() => {
    const slider = document.querySelector('.cart-drawer-testimonials');
    if (slider && typeof Flickity !== 'undefined' && !slider.classList.contains('flickity-enabled')) {
      initCartDrawerTestimonials();
      clearInterval(pollInterval);
    }

    if (++attempts >= maxAttempts) {
      clearInterval(pollInterval);
    }
  }, 300);


